module.exports = new __parcel__URL__("_sprite.1d305b94.svg").toString();